import React, { useState } from "react";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import { Grid, Icon, IconButton, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import {
  UPDATE_DOC_ERROR,
  UPDATE_DOC_LOADING,
  UPDATE_DOC_SUCCESS,
} from "../../store/types/billTypes";
import { Formik } from "formik";
import CoreTextField from "../../core/inputs/CoreTextField";
import {
  fieldEditSchema,
  fieldEditSchemaMulti,
} from "../../formSchemas/docSchemas";
import CoreFormHelperText from "../../core/dataDisplay/CoreFormHelperText";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import CoreIconButton from "../../core/inputs/CoreIconButton";
import CoreSelect from "../../core/inputs/CoreSelect";
import CoreDatePicker from "../../core/inputs/CoreDatePicker";
import CoreAsyncSelect from "../../core/inputs/CoreAsyncSelect";

export default function EditableDocData({ data, docHisId, typeMap, valMap }) {
  const dispatch = useDispatch();
  const [editable, setEditable] = useState({});
  const [value, setValue] = useState({});

  const userId = useSelector((state) => state.auth?.uid);
  const docId = useSelector((state) => state.bill?.docId);
  const newDocHisId = useSelector((state) => state.bill.newDocHisId);

  const userSettings = useSelector((state) => state?.common?.userSettings);

  const multiLine = userSettings?.find((set) => set.name === "multi-line-input")
    ? userSettings?.find((set) => set.name === "multi-line-input")?.value
        ?.enabled
    : false;
  const dangerousCharAllowed = userSettings?.find(
    (set) => set.name === "dangerous-char-allowed",
  )
    ? userSettings?.find((set) => set.name === "dangerous-char-allowed")?.value
        ?.enabled
    : false;

  const setEditMode = (id, val) => {
    console.log("edit called");
    setEditable({ ...editable, [String(id)]: true });
    setValue({ ...value, [String(id)]: val });
  };

  const changeHandler = (val, id) => {
    setValue({ ...value, [String(id)]: val });
  };

  const onCancel = (e) => {
    const id = e.target.id.replace("cancel-", "").replace("cancelicon-", "");
    console.log("cancel", e.target);

    setEditable({ ...editable, [String(id)]: false });
    setValue({ ...value, [String(id)]: "" });
  };

  const onSave = (id) => {
    if (!newDocHisId) {
      dispatch(
        api_request(
          "POST",
          "/error/notification",
          {
            userId,
            docId,
          },
          {},
          "ERROR_NOTIFICATION_LOADING",
          "ERROR_NOTIFICATION_SUCCESS",
          "ERROR_NOTIFICATION_ERROR",
          true,
          false,
          true,
        ),
      );
    }
    dispatch(
      api_request(
        "POST",
        "/doc/data/" + id + "/update",
        {
          value: value[String(id)],
          docHistoryId: newDocHisId || docHisId,
          newHistoryFlag: newDocHisId ? false : true,
        },
        {},
        UPDATE_DOC_LOADING,
        UPDATE_DOC_SUCCESS,
        UPDATE_DOC_ERROR,
        true,
        false,
        true,
      ),
    );
    setEditMode({});
  };

  const saveBulkEdit = () => {
    if (!newDocHisId) {
      dispatch(
        api_request(
          "POST",
          "/error/notification",
          {
            userId,
            docId,
          },
          {},
          "ERROR_NOTIFICATION_LOADING",
          "ERROR_NOTIFICATION_SUCCESS",
          "ERROR_NOTIFICATION_ERROR",
          true,
          false,
          true,
        ),
      );
    }
    dispatch(
      api_request(
        "PUT",
        "/doc/data/bulk",
        {
          dataArr: Object.entries(value)
            .map(([key, value]) => ({ id: key, value }))
            .filter((item) => editable[String(item.id)]),
          docHistoryId: newDocHisId || docHisId,
          newHistoryFlag: newDocHisId ? false : true,
        },
        {},
        UPDATE_DOC_LOADING,
        UPDATE_DOC_SUCCESS,
        UPDATE_DOC_ERROR,
        true,
        false,
        true,
      ),
    );
    setEditMode({});
  };

  console.log("render editable data", typeMap, valMap);

  return (
    <Grid item xs={12}>
      <div
        style={{
          marginTop: "-58px",
          position: "fixed",
          marginLeft: "20%",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "8px",
          }}
        >
          <CoreIconButton onClick={saveBulkEdit}>
            <Tooltip title="Save All" placement="top">
              <Icon>save</Icon>
            </Tooltip>
          </CoreIconButton>
        </div>
      </div>
      <div>
        <Grid container spacing={2}>
          {data?.map((field, i) => (
            <Formik
              initialValues={{ [field.id]: field.value }}
              validationSchema={
                multiLine
                  ? fieldEditSchemaMulti(field.id, dangerousCharAllowed)
                  : fieldEditSchema(field.id, dangerousCharAllowed)
              }
              onSubmit={(values, actions) => {
                onSave(field.id);
              }}
              enableReinitialize
            >
              {(formikProps) => (
                <Grid item xs={12} sm={6}>
                  <Grid container>
                    <Grid
                      xs={editable?.[String(field.id)] ? 8 : 12}
                      style={{ cursor: "pointer" }}
                      id={field.id}
                      onClick={() => {
                        setEditMode(field.id, field.value);
                      }}
                    >
                      {editable?.[String(field.id)] ? (
                        <>
                          {typeMap && typeMap[field.name] === "select" ? (
                            <CoreSelect
                              id={field?.id}
                              value={formikProps.values?.[field?.id]}
                              label={field.label}
                              formikProps={formikProps}
                              handleChange={(e) => {
                                changeHandler(e.target.value, field?.id);
                                formikProps.setFieldValue(
                                  field?.id,
                                  e.target.value,
                                );
                              }}
                              options={valMap ? valMap[field.name] : []}
                            />
                          ) : typeMap && typeMap[field.name] === "date" ? (
                            <CoreDatePicker
                              id={field?.id}
                              value={formikProps.values?.[field?.id]}
                              label={field.label}
                              formikProps={formikProps}
                              onChange={(val) => {
                                console.log("date change", val);
                                changeHandler(val, field?.id);
                                formikProps.setFieldValue(field?.id, val);
                              }}
                            />
                          ) : typeMap &&
                            typeMap[field.name] === "asyncselect" ? (
                            <CoreAsyncSelect
                              id={field?.id}
                              value={formikProps.values?.[field?.id]}
                              label={field.label}
                              formikProps={formikProps}
                              onChange={(val) => {
                                changeHandler(val, field?.id);
                                formikProps.setFieldValue(field?.id, val);
                              }}
                              apiPath={
                                valMap ? valMap[field.name + "_apiPath"] : ""
                              }
                            />
                          ) : (
                            <CoreTextField
                              multiline={multiLine}
                              maxRows={multiLine ? 4 : 1}
                              minRows={multiLine ? 4 : 1}
                              id={field?.id}
                              onChange={(e) => {
                                changeHandler(e.target.value, field?.id);
                                formikProps.handleChange(e);
                              }}
                              value={formikProps.values?.[field?.id]}
                              formikProps={formikProps}
                              fullWidth={true}
                              variant="standard"
                              label={field.label}
                              type={
                                typeMap && typeMap[field.name] === "number"
                                  ? "number"
                                  : "text"
                              }
                            />
                          )}
                          {formikProps.errors &&
                          formikProps.errors[field?.id] ? (
                            <CoreFormHelperText error>
                              {formikProps.errors[field?.id]}
                            </CoreFormHelperText>
                          ) : null}
                        </>
                      ) : (
                        <div>
                          <CoreTypographyBody1>
                            <strong>{field.label}</strong>
                          </CoreTypographyBody1>
                          <CoreTypographyBody1 style={{ textAlign: "justify" }}>
                            {field.value}
                          </CoreTypographyBody1>
                        </div>
                      )}
                    </Grid>
                    {editable?.[String(field.id)] && (
                      <Grid xs={4}>
                        <IconButton
                          id={`cancel-${field.id}`}
                          onClick={onCancel}
                        >
                          <Icon id={`cancelicon-${field.id}`}>cancel</Icon>
                        </IconButton>
                        <IconButton
                          id={`save-${field.id}`}
                          onClick={formikProps.handleSubmit}
                        >
                          <Icon id={`saveicon-${field.id}`}>save</Icon>
                        </IconButton>
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              )}
            </Formik>
          ))}
        </Grid>
      </div>
    </Grid>
  );
}
